// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import BaseIcon, { type IconProps } from './BaseIcon'
import { avatarBgCss, avatarFaceCss, avatarShadowCss, avatarHairCss, avatarShirtCss } from './avatarStyles'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path fill="#ffd2d2" d="M0 0h24v24H0z" className={avatarBgCss} />
    <path
      fill="#dd2762"
      d="M17.09 5.63 7.46 5s1.1 13.85 1 13.78a5.89 5.89 0 0 1-1 .26l.94 2.23 7.5-.16Z"
      className={avatarFaceCss}
    />
    <path
      fill="#cb1f57"
      d="m15.34 18.74-.71-4-.48.72a5.32 5.32 0 0 1-1.1 1.22 2.15 2.15 0 0 1-1.74-.05 7.51 7.51 0 0 1-1-.87c-.18-.2-.58-.76-.87-1.07 0 .22.34 1.64.34 1.73a5.91 5.91 0 0 0 5.56 2.32Z"
      className={avatarShadowCss}
    />
    <path
      fill="#6e0d33"
      d="M19.45 11.44A3.18 3.18 0 0 1 19 9.25c-.34-1.27-.86-3.48-2.23-4.6-.64-.5-1.22-1.63-2.24-1.76a4.19 4.19 0 0 0-1 .09s-1.77-.85-2.86-.45C9.73 2.62 4.45 6.59 6 8c0 0-.32.1-.44-.53a1.29 1.29 0 0 0 0 1.18s-1.72 1.89-1.24 2.86a5.19 5.19 0 0 0 .31.5c-.3.33-1 1.17-.71 1.85.1.26-.09.44 0 .59a1.07 1.07 0 0 0 .64.54l.3.88c.62 1.92 2.48 2.35 4.2 3.22-.25-.84.32-.79.55-1.45a5.94 5.94 0 0 0 .27-2.29 1.3 1.3 0 0 0-.2-.49A4.38 4.38 0 0 1 8.33 12c.05-.5-.19-.7-.18-1.29s.38.13.43-.11c.09-.46.13-1.31.37-1.53.79-.74.46-.2 1.36-1C11.53 7 10.62 8 11.53 7a6.67 6.67 0 0 1 1.74-1.29A3 3 0 0 0 15.1 7c.39.21.12 1.45.1 2.05 0 .44 0 1.22.44 1.22.76-.75 1 .36.95 1.13a1.85 1.85 0 0 1-.07.41 1.42 1.42 0 0 1-.14.36c-.11.34-.81.18-.78.37a2 2 0 0 1 0 .78 5.53 5.53 0 0 1-1 1.48c-.25.35-.68 2.45-.06 3.15a2.54 2.54 0 0 0 .73.73 3.69 3.69 0 0 0 1.87.44 2.62 2.62 0 0 1 .35-1.6 6.38 6.38 0 0 1 1-.8s.78-.83.38-1 .23-.41.23-.41l-.49-.31s.67-.15.44-.48.68-1.41.68-1.41.4-.52-.28-1.67Z"
      className={avatarHairCss}
    />
    <path
      fill="#a0084c"
      d="M20.28 24a6.45 6.45 0 0 0 .39-2.22c-.58-1.6-3.76-2.45-4.1-2.59s-1.09-.37-1.09-.37l-.11.21s-.68 2-3.86 2a4.29 4.29 0 0 1-3.44-2.13c-.72.2-4.74.58-4.74 2.86a6.87 6.87 0 0 0 .4 2.24Z"
      className={avatarShirtCss}
    />
  </BaseIcon>
)
